/* ============================================================
   CRIT THREADS - brand interactions (vanilla, no libraries)
   d20 add-to-cart roll · sticky mobile ATC · free-shipping bar
   refresh · newsletter popup · size-guide unit toggle
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var D20 =
    '<svg width="20" height="20" viewBox="0 0 72 72" aria-hidden="true">' +
    '<polygon points="36,4 63.7,20 63.7,52 36,68 8.3,52 8.3,20" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/>' +
    '<polygon points="36,15 55.5,49 16.5,49" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/></svg>';

  /* -------- d20 add-to-cart roll -------------------------- */
  function rollButton(btn) {
    if (!btn || btn.dataset.ctRolling === '1') return;
    var textEl = btn.querySelector('span:not(.ct-atc-glyph)') || btn;
    var original = btn.getAttribute('data-ct-label') || textEl.textContent;
    btn.setAttribute('data-ct-label', original);

    if (REDUCED) {
      textEl.textContent = 'Added ✓';
      setTimeout(function () { textEl.textContent = original; }, 1400);
      popBubble();
      return;
    }

    btn.dataset.ctRolling = '1';
    var glyph = document.createElement('span');
    glyph.className = 'ct-atc-glyph ct-d20-rolling';
    glyph.innerHTML = D20;
    btn.insertBefore(glyph, btn.firstChild);

    var face = 20;
    var iv = setInterval(function () {
      face = 1 + Math.floor(Math.random() * 20);
      textEl.textContent = 'ROLLING… ' + face;
    }, 70);

    setTimeout(function () {
      clearInterval(iv);
      btn.classList.add('ct-done');
      textEl.textContent = '⬢ NAT 20! ADDED TO CART';
      popBubble();
      setTimeout(function () {
        btn.classList.remove('ct-done');
        if (glyph.parentNode) glyph.parentNode.removeChild(glyph);
        textEl.textContent = original;
        btn.dataset.ctRolling = '0';
      }, 1400);
    }, 700);
  }

  function popBubble() {
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;
    bubble.classList.remove('ct-pop');
    void bubble.offsetWidth; /* reflow to restart animation */
    bubble.classList.add('ct-pop');
  }

  /* Hook any add-to-cart submit (main PDP form + quick add) */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest(
        '.product-form__submit, .quick-add__submit, [data-ct-roll]'
      );
      if (btn && !btn.disabled) rollButton(btn);
    },
    true
  );

  /* Also pop the badge whenever Dawn reports a cart update */
  document.subscribe && document.subscribe('cart-update', popBubble);
  document.addEventListener('cart:refresh', popBubble);

  /* Keep the "YOUR HAUL (n)" count in sync with the cart bubble */
  function syncHaulCount() {
    var haul = document.querySelector('.ct-haul-count');
    var bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span');
    if (haul && bubble) haul.textContent = '(' + bubble.textContent.trim() + ')';
  }

  /* -------- One-tap cart-drawer upsell -------------------- */
  function getInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-ct-upsell-add]');
    if (!add) return;
    e.preventDefault();
    var id = add.getAttribute('data-variant-id');
    if (!id || add.dataset.busy === '1') return;
    add.dataset.busy = '1';
    add.textContent = '…';

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: body,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var sections = data.sections || {};
        var drawerHtml = sections['cart-drawer'];
        if (drawerHtml) {
          var items = document.querySelector('cart-drawer-items');
          var footer = document.querySelector('.cart-drawer__footer');
          var newItems = getInner(drawerHtml, 'cart-drawer-items');
          var newFooter = getInner(drawerHtml, '.cart-drawer__footer');
          if (items && newItems != null) items.innerHTML = newItems;
          if (footer && newFooter != null) footer.innerHTML = newFooter;
        }
        var bub = sections['cart-icon-bubble'];
        if (bub) {
          var target = document.getElementById('cart-icon-bubble');
          if (target) target.innerHTML = getInner(bub, '.shopify-section') || bub;
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
        }
        popBubble();
        syncHaulCount();
      })
      .catch(function () { add.textContent = '+'; })
      .finally(function () { add.dataset.busy = '0'; });
  });

  /* -------- Sticky mobile add-to-cart bar ----------------- */
  function initStickyAtc() {
    var main = document.querySelector('[data-ct-atc-anchor]');
    var bar = document.querySelector('.ct-sticky-atc');
    if (!main || !bar || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    io.observe(main);
  }

  /* -------- Collection "Load more" (AJAX append) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ct-loadmore-btn]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-ct-loadmore]');
    var sectionId = wrap ? wrap.getAttribute('data-section-id') : null;
    var href = btn.getAttribute('href');
    if (!href || btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    btn.textContent = 'LOADING…';

    var targetSel = wrap.getAttribute('data-ct-grid') || '#product-grid';
    var url = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var currentGrid = document.querySelector(targetSel);
        var newGrid = doc.querySelector(targetSel);
        if (currentGrid && newGrid) {
          Array.prototype.forEach.call(newGrid.children, function (li) {
            currentGrid.appendChild(li.cloneNode(true));
          });
        }
        var newBtn = doc.querySelector('[data-ct-loadmore-btn]');
        var shownEl = wrap && wrap.querySelector('[data-ct-shown]');
        var newShown = doc.querySelector('[data-ct-shown]');
        if (shownEl && newShown) shownEl.textContent = newShown.textContent;
        if (newBtn) {
          btn.setAttribute('href', newBtn.getAttribute('href'));
          btn.textContent = 'LOAD MORE';
          btn.dataset.busy = '0';
        } else {
          btn.remove();
        }
      })
      .catch(function () { btn.textContent = 'LOAD MORE'; btn.dataset.busy = '0'; });
  });

  /* -------- Size-guide unit toggle (persisted) ------------ */
  function initSizeGuide() {
    var root = document.querySelector('[data-ct-sizeguide]');
    if (!root) return;
    var stored = localStorage.getItem('ct-size-unit') || 'cm';
    applyUnit(root, stored);

    function openSheet() {
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    }
    function closeSheet() {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 240);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-ct-sizeguide-open]')) { e.preventDefault(); openSheet(); }
      else if (e.target.closest('[data-ct-sizeguide-close]')) { closeSheet(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) closeSheet();
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ct-unit]');
      if (!t) return;
      var unit = t.getAttribute('data-ct-unit');
      localStorage.setItem('ct-size-unit', unit);
      applyUnit(root, unit);
    });
  }
  function applyUnit(root, unit) {
    root.querySelectorAll('[data-ct-unit]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-ct-unit') === unit);
    });
    root.querySelectorAll('[data-cm]').forEach(function (cell) {
      cell.textContent = unit === 'cm' ? cell.getAttribute('data-cm') : cell.getAttribute('data-in');
    });
  }

  /* -------- Newsletter popup ------------------------------- */
  function initPopup() {
    var pop = document.querySelector('[data-ct-popup]');
    if (!pop) return;
    var KEY = 'ct-popup-dismissed';
    var stored = parseInt(localStorage.getItem(KEY) || '0', 10);
    var suppressDays = parseInt(pop.getAttribute('data-suppress-days') || '30', 10);
    var path = window.location.pathname;
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;
    if (stored === -1) return; /* signed up = forever */
    if (stored && Date.now() - stored < suppressDays * 864e5) return;

    var pageViews = parseInt(sessionStorage.getItem('ct-pageviews') || '0', 10) + 1;
    sessionStorage.setItem('ct-pageviews', pageViews);
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      var input = pop.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus(); }, 300);
    }
    function close(forever) {
      pop.classList.remove('is-open');
      localStorage.setItem(KEY, forever ? '-1' : String(Date.now()));
      setTimeout(function () { pop.hidden = true; }, 260);
    }

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-ct-popup-close]') || e.target === pop) close(false);
    });
    pop.querySelector('form') &&
      pop.querySelector('form').addEventListener('submit', function () {
        localStorage.setItem(KEY, '-1');
      });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) close(false);
    });

    if (isMobile) {
      if (pageViews >= 2) {
        window.addEventListener('scroll', function onScroll() {
          var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
          if (pct >= 0.6) { window.removeEventListener('scroll', onScroll); show(); }
        });
      }
    } else {
      if (pageViews >= 2) setTimeout(show, 30000);
      document.addEventListener('mouseout', function (e) {
        if (e.clientY <= 0) show();
      });
    }
  }

  /* -------- boot ------------------------------------------ */
  function boot() {
    initStickyAtc();
    initSizeGuide();
    initPopup();
    syncHaulCount();
    document.subscribe && document.subscribe('cart-update', syncHaulCount);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
